import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import * as bootstrap from 'bootstrap';
import { CommentComponent } from '../comment/comment.component';

@Component({
  selector: 'citizen-issue',
  standalone: true,
  imports: [CommonModule, FormsModule, CommentComponent ],
  templateUrl: './issue-card.component.html',
  styleUrls: ['./issue-card.component.css']
})
export class IssueCardComponent implements OnInit {
  @Input() data: any = {
    data: {
    title: "पुणे: पैदल यात्री दिवस की आलोचना, नागरिकों ने दीर्घकालिक समाधान की मांग की।पुणे: पैदल यात्री दिवस की आलोचना, नागरिकों ने दीर्घकालिक समाधान की मांग की।पुणे: पैदल यात्री दिवस की आलोचना, नागरिकों ने दीर्घकालिक समाधान की मांग की।पुणे: पैदल यात्री दिवस की आलोचना, नागरिकों ने दीर्घकालिक समाधान की मांग की।",
    Owner: {
      name: "Vishal Aher",
      type: "leader",
      profilePicture: "https://images.pexels.com/photos/326055/pexels-photo-326055.jpeg?auto=compress&cs=tinysrgb&w=600",
      address: {
        location: "Pune H.O",
      }
    },
    created: "Jan 20, 2025",
    origionalItem: {
      description: "पुणे के पैदल यात्री दिवस पर पुणे महानगरपालिका (PMC) से नागरिकों की अपेक्षाएं बढ़ींपुणे के पैदल यात्री दिवस पर पुणे महानगरपालिका (PMC) से नागरिकों की अपेक्षाएं बढ़ींपुणे के पैदल यात्री दिवस पर पुणे महानगरपालिका (PMC) से नागरिकों की अपेक्षाएं बढ़ीं...पुणे के पैदल यात्री दिवस पर पुणे महानगरपालिका (PMC) से नागरिकों की अपेक्षाएं बढ़ीं...पुणे के पैदल यात्री दिवस पर पुणे महानगरपालिका (PMC) से नागरिकों की अपेक्षाएं बढ़ीं...पुणे के पैदल यात्री दिवस पर पुणे महानगरपालिका (PMC) से नागरिकों की अपेक्षाएं बढ़ीं...पुणे के पैदल यात्री दिवस पर पुणे महानगरपालिका (PMC) से नागरिकों की अपेक्षाएं बढ़ीं...पुणे के पैदल यात्री दिवस पर पुणे महानगरपालिका (PMC) से नागरिकों की अपेक्षाएं बढ़ीं...पुणे के पैदल यात्री दिवस पर पुणे महानगरपालिका (PMC) से नागरिकों की अपेक्षाएं बढ़ीं...पुणे के पैदल यात्री दिवस पर पुणे महानगरपालिका (PMC) से नागरिकों की अपेक्षाएं बढ़ीं...पुणे के पैदल यात्री दिवस पर पुणे महानगरपालिका (PMC) से नागरिकों की अपेक्षाएं बढ़ीं...पुणे के पैदल यात्री दिवस पर पुणे महानगरपालिका (PMC) से नागरिकों की अपेक्षाएं बढ़ीं",
    },
    status: 'New',
    share: 'Share',
    image: "https://iamcitizen.in/api/download/iamcitizen.in/ravi/shared%20image.jpeg",
    category: "MunicipalCorporation",
    type: "Parks And Public Spaces Maintenance",
    LikeDislikeSummary: {
      likes: 0,
      dislikes: 0,
    }
    }
  };

  @Input() config: any = {
    wrapperClass: 'wrapper',
    containerClass: 'container mt-4',
    rowClass: 'row news-card shadow-lg p-3 bg-white rounded',
    leftImageClass: 'col-lg-4 d-none d-lg-block',
    imageClass: 'news-image img-fluid rounded',
    cardClass: 'col-lg-8 col-12',
    authorClass: 'd-flex align-items-center mb-2',
    profileClass: 'profile-img me-2 img-fluid rounded-circle w-25 h-25 object-fit-cover',
    profileButtonClass: 'btn',
    textClass: 'text-muted fw-bold mb-1',
    dateClass: 'text-muted small mb-0',
    statusButtonClass: 'btn btn-outline-secondary btn-sm ms-auto share-btn',
    shareButtonClass: 'btn btn-outline-warning btn-sm ms-2',
    mobileImageClass: 'd-lg-none text-center mb-3',
    titleClass: 'fw-bold',
    descriptionClass: 'text-muted',
    tagsClass: 'mb-2',
    badgeClass: 'badge text-black me-1',
    reactionClass: 'd-flex align-items-center mb-2',
    likeButtonClass: 'btn btn-light btn-sm me-2',
    dislikeButtonClass: 'btn btn-light btn-sm me-2',
    commentButtonClass: 'btn btn-light btn-sm',
    modalClass: 'modal fade',
    modalDialogClass: 'modal-dialog modal-dialog-centered modal-lg',
    modalContentClass: 'modal-content',
    modalBodyClass: 'modal-body text-center',
    modalImageClass: 'img-fluid rounded',
    modalFooterClass: 'modal-footer',
    closeButtonClass: 'btn btn-primary',
    useIcons: false,
    profileDetailsClass: 'd-flex flex-column',
  };
  commentData={}
  shareModel: any   
  commentConfig={
    
  }

  selectedImage: string = '';
  isLiked: boolean = false;
  isDisliked: boolean = false;
  likeCount: number = 0;
  dislikeCount: number = 0;
 

  openModal(image: string) {
    this.selectedImage=''
    console.log("Model Image", image,this.selectedImage)
    this.selectedImage = image;
    const modalElement = document.getElementById('imageModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  commentBoxVisible: boolean = false;
  selectedData: any = null;

   openCommentModal(event: Event) {
      
      const modalElement = document.getElementById('commentModal');
      if (!modalElement) {
        console.error("Modal element not found!");
        return;
      }
      const commentModal = new bootstrap.Modal(modalElement);
      commentModal.show();    
    }

    newComment = '';
    comments = 0;

  ngOnInit(): void {
    try {
      this.data = typeof this.data === 'string' ? JSON.parse(this.data) : this.data;
      this.config = typeof this.config === 'string' ? JSON.parse(this.config) : this.config;
      this.commentData={
        referenceId : this.data.data?.id,
        relatedTo: `citizen-issues`
      }
    } catch (error) {
      console.error("Error parsing input data/config:", error);
    }  
    console.log("Issue-card data: ",this.data);
    this.shareModel = {
      widgetId: "679462f7c233a75cbff31f79",
        url: `https://iamcitizen.in/w/67aafa82421da18c453a9b7c/SingleIssue?dataModel=citizen-issues%2Fsearch&dataParams=%7B"where":%7B"id":"${this.data.data?.id}"%7D%7D`,
       
          socialShareLinks: [
          { name: 'whatsapp', icon: 'bi bi-whatsapp fs-1', url: `https://iamcitizen.in/w/67aafa82421da18c453a9b7c/SingleIssue?dataModel=citizen-issues%2Fsearch&dataParams=%7B"where":%7B"id":"${this.data.data?.id}"%7D%7D` },
          { name: 'facebook', icon: 'bi bi-facebook fs-1', url: `https://iamcitizen.in/w/67aafa82421da18c453a9b7c/SingleIssue?dataModel=citizen-issues%2Fsearch&dataParams=%7B"where":%7B"id":"${this.data.data?.id}"%7D%7D`},
          { name: 'twitter', icon: 'fs-1 bi bi-twitter', url: `https://iamcitizen.in/w/67aafa82421da18c453a9b7c/SingleIssue?dataModel=citizen-issues%2Fsearch&dataParams=%7B"where":%7B"id":"${this.data.data?.id}"%7D%7D` },
          { name: 'linkedin', icon: 'bi bi-linkedin fs-1', url: `https://iamcitizen.in/w/67aafa82421da18c453a9b7c/SingleIssue?dataModel=citizen-issues%2Fsearch&dataParams=%7B"where":%7B"id":"${this.data.data?.id}"%7D%7D` },
          { name: 'copy', icon: 'fs-1 bi bi-link', url: `https://iamcitizen.in/w/67aafa82421da18c453a9b7c/SingleIssue?dataModel=citizen-issues%2Fsearch&dataParams=%7B"where":%7B"id":"${this.data.data?.id}"%7D%7D` }
        ]
     
    };

    this.likeCount = this.data?.data?.LikeDislikeSummary?.likes || 0;
    this.dislikeCount = this.data?.data?.LikeDislikeSummary?.dislikes || 0;
    
    this.viewContainer.element.nativeElement.addEventListener('responseData', this.handleResponse.bind(this));
    this.viewContainer.element.nativeElement.dispatchEvent(new CustomEvent('requestData', {
      bubbles: true,
      cancelable: true,
      detail: {
        data: {
          isExternalRedirect: false,
          dataModel: "favourites",
          dataParams: {
            referenceId: this.data?.data?.id,
            relatedTo: "citizen-issues",
            userId: this.data?.UserDetails?.id
          },
          fieldId: "like-dislike"
        }
      }
      
    }));

  }

  handleResponse(event: any) {
    console.log("Response received: ", event.detail);

    if (event.detail?.data?.LikeDislikeSummary) {
      this.likeCount = event.detail.data.LikeDislikeSummary.likes || this.likeCount;
      this.dislikeCount = event.detail.data.LikeDislikeSummary.dislikes || this.dislikeCount;
    }

    this.viewContainer.element.nativeElement.addEventListener('responseData', this.handleResponse.bind(this), { once: true });

  }

  constructor(private viewContainer: ViewContainerRef) {}

  onShareClick(event: any) {
    console.log("Share button clicked:", event);
   
    event.stopPropagation();
    const customEvent = new CustomEvent('modal', {
      bubbles: true,
      cancelable: true,
      detail: { data: this.shareModel }
    });

    this.viewContainer.element.nativeElement.dispatchEvent(customEvent);
  }

  toggleButtonClick(type:string){

    if (!this.data?.UserDetails?.id) return; // User login check

  if (type === 'like') {
    if (this.isLiked) {
      // Already liked hai, toh remove karna hai
      this.isLiked = false;
      this.likeCount--;
      this.postData(null);
    } else {
      // Like set karein, aur agar pehle dislike tha toh remove karein
      this.isLiked = true;
      this.isDisliked = false;
      this.likeCount++;
      if (this.isDisliked) this.dislikeCount--;
      this.postData(true);
    }
  } else if (type === 'dislike') {
    if (this.isDisliked) {
      // Already disliked hai, toh remove karna hai
      this.isDisliked = false;
      this.dislikeCount--;
      this.postData(null);
    } else {
      // Dislike set karein, aur agar pehle like tha toh remove karein
      this.isDisliked = true;
      this.isLiked = false;
      this.dislikeCount++;
      if (this.isLiked) this.likeCount--;
      this.postData(false);
    }
  }
  }

  // getData(CustomEvent:any, fieldId: string) {
  //   const customEvent = new CustomEvent('requestData', {
  //     bubbles: true,
  //     cancelable: true,
  //     detail: { 
  //       data: { 
  //         isExternalRedirect: false,
  //         dataModel: "favourites",
  //         dataParams: {
  //           referenceId: this.data?.data?.id,
  //           relatedTo: "citizen-issues",
  //           userId: this.data?.UserDetails?.id
  //         }, 
  //         fieldId: fieldId
  //       } 
  //     }
  //   });
  //   this.viewContainer.element.nativeElement.dispatchEvent(customEvent);
  //   const responseHandler = (event: any) => {
      
  //     let eventDetail = event.detail.res;
  //     // if(event.detail.fieldId !==this.data?.data?.id)return
  //     console.log("Response received eventDetailres:", eventDetail);

  //     if (eventDetail.likedislike === 'like') {
  //       this.likedislike = 'like';
  //     } else if (eventDetail.likedislike === 'dislike') {
  //       this.likedislike = 'dislike';
  //     } else {
  //       this.likedislike = null;
  //     }
  //   };
  //   this.viewContainer.element.nativeElement.addEventListener('responseData', responseHandler);
  // }

  postData(status:boolean | null){
    if(!this.data.UserDetails?.id) return
    const customEvent = new CustomEvent('submit', {
      bubbles: true,
      cancelable: true,
      detail: { 
        isExternalRedirect: false,
        data: { 
          data: {
            referenceId: this.data?.data?.id,
            relatedTo: "citizen-issues",
            userId: this.data?.UserDetails?.id,
            likeDislike: status,
        }, 
          dataModel: "favourites" 
        } 
      }
    });

    if (this.viewContainer?.element.nativeElement) {
      // Pehle se attached listener ko remove karein
      this.viewContainer.element.nativeElement.removeEventListener('responseData', this.handleResponse.bind(this));
    
      // Ab naya listener add karein
      this.viewContainer.element.nativeElement.addEventListener('responseData', this.handleResponse.bind(this));
    }
    
    
    console.log('Like/Dislike Updated:', status);
    this.viewContainer.element.nativeElement.dispatchEvent(customEvent);
  }

  redirectToCitizenProfile() {
    if (!this.data?.userId) {
      console.error('User ID is missing');
      return;
    }

    const citizenId = this.data?.WidgetDetails?.config?.citizenProfiLinkToId || 'defaultId';

    const dataParams = {
      where: {
        id: this.data.userId
      }
    };

    let queryParams = {
      dataModel: 'citizen-users/search',
      dataParams: JSON.stringify(dataParams)
    };

    console.log(JSON.stringify(dataParams));

    const customEvent = new CustomEvent('redirect', {
      bubbles: true,
      cancelable: true,
      detail: {
        data: {
          isExternalRedirect: false,
          redirectUrl: `/w/${citizenId}/addCitizenProfile`,
          queryParams: JSON.stringify(queryParams)
        }
      }
    });

    this.viewContainer.element.nativeElement.dispatchEvent(customEvent);
  }

  redirectToSingleIssue() {
    if (!this.data?.id) {
      console.error('Issue ID is missing');
      return;
    }

    const id = this.data?.WidgetDetails?.config?.SingleIssueLinkToId || 'defaultId';

    const dataParams = {
      where: {
        id: this.data.id
      }
    };

    let queryParams = {
      dataModel: 'citizen-issues/search',
      dataParams: JSON.stringify(dataParams)
    };

    console.log(JSON.stringify(dataParams));

    const customEvent = new CustomEvent('redirect', {
      bubbles: true,
      cancelable: true,
      detail: {
        data: {
          isExternalRedirect: false,
          redirectUrl: `/w/${id}/SingleIssue`,
          queryParams: JSON.stringify(queryParams)
        }
      }
    });

    this.viewContainer.element.nativeElement.dispatchEvent(customEvent);
  }

}
